import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        redirect: '/lediga-lagenheter',
    },
    {
        path: '/lediga-lagenheter',
        component: () => import('../views/AppartmentSearch.vue'),
    },
    {
        path: '/lediga-lagenheter/:id',
        component: () => import('../views/AppartmentDetail.vue'),
    },
    {
        path: '/lediga-lagenheter/ny-intresseanmalan',
        component: () => import('../views/CreateApartmentNoteOfInterestSuccess.vue'),
    },
    {
        path: '/co-living',
        component: () => import('../views/CoLivingApartmentSearch.vue'),
    },
    {
        path: '/co-living/:id',
        component: () => import('../views/CoLivingApartmentDetails.vue'),
    },
    {
        path: '/lediga-korttidslagenheter',
        component: () => import('../views/ShortTimeAppartmentSearch.vue'),
    },
    {
        path: '/lediga-korttidslagenheter/:id',
        component: () => import('../views/ShortTimeAppartmentDetail.vue'),
    },
    {
        path: '/nyproduktion',
        component: () => import('../views/NewProductionAppartmentSearch.vue'),
    },
    {
        path: '/nyproduktion/:id',
        component: () => import('../views/NewProductionAppartmentDetail.vue'),
    },
    {
        path: '/lediga-parkeringsplatser',
        component: () => import('../views/ParkingSearch.vue'),
    },
    {
        path: '/lediga-parkeringsplatser/:id',
        component: () => import('../views/ParkingDetail.vue'),
    },
    {
        path: '/lediga-parkeringsplatser/nytt-kontrakt',
        component: () => import('../views/CreateParkingSpaceLeaseSuccess.vue'),
    },
    {
        path: '/lediga-parkeringsplatser/ny-intresseanmalan',
        component: () => import('../views/CreateParkingSpaceNoteOfInterestSuccess.vue'),
    },
    {
        path: '/lediga-forrad',
        component: () => import('../views/StorageSearch.vue'),
    },
    {
        path: '/lediga-forrad/:id',
        component: () => import('../views/StorageDetail.vue'),
    },
];

const router = createRouter({
    history: createWebHistory('sok-ledigt'),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

export default router;
